(function () {
	document.addEventListener('shopify:section:load', function () {
		setTimeout(function () {
			sliderInit(true);
			subSliderInit(true);
		}, 100);
	});

	const { reveal, conceal } = window.AccordionPanel;

	const closeItem = (activeItem) => {
		const activeButton = activeItem.querySelector(".about__accordion-button");
		const activePanel =
			activeButton &&
			document.getElementById(activeButton.getAttribute("aria-controls"));

		activeItem.classList.remove("active");
		if (activeButton) {
			activeButton.classList.remove("active");
			activeButton.setAttribute("aria-expanded", "false");
		}
		conceal(activePanel);
	};

	const toggleAccordion = (button) => {
		const item = button.closest(".about__accordion-item");
		const scope =
			item.closest(".about__wrapper") ||
			item.closest(".product__info-container") ||
			item.parentElement;
		const panel = document.getElementById(button.getAttribute("aria-controls"));
		const isExpanded = button.getAttribute("aria-expanded") === "true";

		if (!isExpanded) {
			scope
				.querySelectorAll(".about__accordion-item.active")
				.forEach(closeItem);

			button.classList.add("active");
			button.setAttribute("aria-expanded", "true");
			reveal(panel, () => {
				item.classList.add("active");
			});
		} else {
			item.classList.remove("active");
			button.classList.remove("active");
			button.setAttribute("aria-expanded", "false");
			conceal(panel);
		}
	};

	const initProductAccordion = () => {
		document
			.querySelectorAll(".about__accordion-button")
			.forEach((button) => {
				if (button.dataset.a11yInit) return;
				button.dataset.a11yInit = "true";
				button.addEventListener("click", () => toggleAccordion(button));
			});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
	});

	initProductAccordion();
})();
